module.exports = __webpack_public_path__ + "img/apple-touch-icon.57d9f11.png";